import React from 'react';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { MiniPurchase } from './components/MiniPurchase';
import { HeroTestimonialsCarousel } from './components/HeroTestimonialsCarousel';
import { Benefits } from './components/Benefits';
import { SystemFeatures } from './components/SystemFeatures';
import { Features } from './components/Features';
import { Content } from './components/Content';
import { Testimonials } from './components/Testimonials';
import { Purchase } from './components/Purchase';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
// TODO: Reemplazar con la URL real del checkout de pago
const CHECKOUT_URL = 'https://checkout.ecompradigital.online/cart/46744733909180:1';
export function App() {
  const smoothScrollTo = (elementId: string) => {
    const element = document.getElementById(elementId);
    if (!element) return;
    const targetPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    const duration = 800;
    let start: number | null = null;
    const easeInOutCubic = (t: number): number => {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    };
    const animation = (currentTime: number) => {
      if (start === null) start = currentTime;
      const timeElapsed = currentTime - start;
      const progress = Math.min(timeElapsed / duration, 1);
      const ease = easeInOutCubic(progress);
      window.scrollTo(0, startPosition + distance * ease);
      if (timeElapsed < duration) {
        requestAnimationFrame(animation);
      }
    };
    requestAnimationFrame(animation);
  };
  const handleCTAClick = () => {
    smoothScrollTo('compra');
  };
  return <div className="w-full min-h-screen bg-[#FAF7F2] pt-10" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <CountdownBar data-id="element-2" />
      <Hero data-id="element-3" />
      <MiniPurchase checkoutUrl={CHECKOUT_URL} data-id="element-4" />
      <HeroTestimonialsCarousel data-id="element-5" />

      {/* Tagline Strip */}
      <div className="bg-white border-y border-gray-200 py-6 shadow-sm" data-id="element-6">
        <div className="container mx-auto px-4 text-center" data-id="element-7">
          <p className="italic text-[#1F3A5F] text-lg md:text-xl max-w-3xl mx-auto font-['Noto_Sans',_sans-serif]" data-id="element-8">
            Material completo para enseñar Lengua y Literatura de 1° a 6° año de
            secundaria, con contenidos, actividades, planificación y
            diapositivas listas para usar.
          </p>
        </div>
      </div>

      <Benefits onCTAClick={handleCTAClick} data-id="element-9" />
      <SystemFeatures onCTAClick={handleCTAClick} data-id="element-10" />
      <Features data-id="element-11" />
      <Content onCTAClick={handleCTAClick} data-id="element-12" />
      <Purchase checkoutUrl={CHECKOUT_URL} data-id="element-13" />
      <Testimonials data-id="element-14" />
      <Footer data-id="element-15" />
      <WhatsAppButton data-id="element-16" />
      <SocialProofPopup data-id="element-17" />
    </div>;
}